import React from "react";
import { useI18n } from "@/i18n";
import { Globe } from "lucide-react";

export function LanguageSelector({ compact = false }) {
  const { lang, setLang } = useI18n();
  return (
    <div data-testid="language-selector" className="inline-flex items-center gap-1.5">
      {!compact && <Globe size={15} className="text-slate-400" aria-hidden />}
      <div className="inline-flex items-center rounded-full border border-slate-200 bg-white overflow-hidden text-xs font-semibold">
        <button
          data-testid="lang-en"
          onClick={() => setLang("en")}
          aria-pressed={lang === "en"}
          className={`px-2.5 py-1 transition-colors ${lang === "en" ? "bg-violet-600 text-white" : "text-slate-600 hover:bg-violet-50"}`}
        >
          EN
        </button>
        <button
          data-testid="lang-ar"
          onClick={() => setLang("ar")}
          aria-pressed={lang === "ar"}
          className={`px-2.5 py-1 transition-colors ${lang === "ar" ? "bg-violet-600 text-white" : "text-slate-600 hover:bg-violet-50"}`}
        >
          AR
        </button>
      </div>
    </div>
  );
}
